import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(postObject: Request): Promise<Optional<string>> {
	const url = `${SERVICEBASEURL.BACKEND}/Nutrient`;
	return axios.post(url, postObject).toOptionalMapped((x) => x.data);
}

export interface Request {
	unitId: string;
	isMacroNutrient: boolean;
	sortOrder: number;
	nutrientCategoryId: string;
	nameTranslations: {
		[key: string]: string;
	};
	shortNameTranslations: {
		[key: string]: string;
	};
}

export interface Response {
	data: string;
}
